<template>
  <div>
    <header>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css">
      <!-- Include CSS do MDB -->
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/mdb-ui-kit/6.4.1/mdb.min.css">
    </header>
    <div class="title-container">
      <h3 class="title">CONFIGURAÇÃO INTEGRAÇÕES</h3>
    </div>
    
    <div style="max-width: 1011px !important;" class="container container-bkg mt-3">
      <fieldset>
        <legend class="legend-border"><i class="fas fa-search"></i>Filtro</legend>
        <hr class="mt-0"/>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-5">
            <div class="form-outline">
              <input type="text" class="form-control" id="codigoOperadora" required oninvalid="this.setCustomValidity('Código Operadora é obrigatório!')" oninput="this.setCustomValidity('')"/>
              <label class="form-label" for="">Código Operadora:</label>
              <FormNotch />
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-5">
            <button class="btn btn-sm btn-primary waves-effect waves-light search-button" @click="pesquisar()">
              <i class="fas fa-search me-1"></i>
              <span class="search-span">Pesquisar</span>
            </button>
          </div>
        </div>
        <hr class="mt-0"/>
      </fieldset>
    </div>

    <div style="max-width: 1011px !important;" class="container container-bkg mt-3" v-if="listas.length > 0">
      <table class="table">
        <tbody id="lista-vendas" model="selectedListasVendas" v-for="lista in listas" :key="lista.id" :value="lista.id">
          <tr>
            <td class="name-line" style="padding-left: 45px !important;padding-top: 3% !important;">
              <a :href="'https://jiratokiomarine.atlassian.net/browse/' + lista.keyJira" target="_blank">{{lista.keyJira.toUpperCase()}}</a>
            </td>
            <td class="name-line" style="padding-left: 45px !important;padding-top: 3% !important;">
              OPERADORA {{lista.codigoOperadora}}
            </td>              
            <td class="name-line" style="padding-left: 45px !important;padding-top: 3% !important;">
              {{lista.catalogo.toUpperCase() + ' - ' + lista.api.toUpperCase() }}
            </td>            
            <td class="status-line">
              {{ lista.situacao }}
            </td>
            <td class="actions-line">
              <button @click="openModal('CONFIGURACAO-ACEITE', lista.id, lista.idCatalogoApi)" v-if="lista.situacao === 'CONFIGURACAO-ACEITE'" class="btn btn-primary pen-button">
                CONFIGURAR ACEITE
              </button>
              <button @click="openModal('CONFIGURACAO-PRODUCAO', lista.id, lista.idCatalogoApi)" v-if="lista.situacao === 'CONFIGURACAO-PRODUCAO'" class="btn btn-primary pen-button">
                CONFIGURAR PRODUÇÃO
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- O Modal -->
    <div v-if="showModal" class="modal fade" id="myModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" style="font-weight: 600;">Configurar Integração</h5>
          <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal" aria-label="Close"></button>
        </div>

        <form id="formIntegracoes" @submit.prevent="salvarDados()">
          <div class="modal-body">
            <div class="col-11 mt-4 m-3">
              <div class="form-outline" v-if="labelCamposAutenticacao.apresenta01 == true">
                <input class="form-control active" id="senhaOperadora" value="" oninvalid="this.setCustomValidity('Esse campo é obrigatório!')" oninput="this.setCustomValidity('')" required>
                <label class="form-label green-label-color" for="">{{ labelCamposAutenticacao.campo01 }}:</label>
                <FormNotch />
              </div>
            </div>
            <div class="col-11 mt-3 m-3" v-if="labelCamposAutenticacao.apresenta02 == true">
              <div class="form-outline">
                <input class="form-control active" id="clientId" value="">
                <label class="form-label green-label-color" for="">{{ labelCamposAutenticacao.campo02 }}:</label>
                <FormNotch />
              </div>
            </div>
            <div class="col-11 mt-4 m-3" v-if="labelCamposAutenticacao.apresenta03 == true">
              <div class="form-outline">
                <input class="form-control active" id="clientSecret" value="">
                <label class="form-label green-label-color" for="">{{ labelCamposAutenticacao.campo03 }}:</label>
                <FormNotch />
              </div>
            </div>
          </div>

          <div class="m-3 mt-3" role="group">
            <div class="row m-1">
              <div class="col-5">
                <button @click="closeModal" type="button" id="vendas" class="footer-button btn btn-primary" style="width: 105% !important;" data-mdb-ripple-init>CANCELAR</button>
              </div>
              <div class="col-1">
              </div>
              <div class="col-3">
                <button type="submit" id="gestao-carteira" style="width: 205% !important;color:white !important" class="footer-button btn btn-primary active save-btn" data-mdb-ripple-init>SALVAR</button>
              </div>
            </div>
          </div>
        </form>


      </div>
      </div>
    </div>

    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>
 
<script>
import * as alertUtils from '@/utils/alert';
import FormNotch from './FormNotch.vue';

import $ from 'jquery'; // Importando jQuery
import 'mdb-ui-kit'; // Importando o JavaScript do MDB
import * as loaderUtils from '@/utils/loader'
import * as ajaxUtils from '@/utils/ajax';

export default {
  data() {
    return {
      selectedListasVendas: "",
      tipoModal: "",
      idIntegracaoApi: "",
      idCatalogoApi: "",
      showModal: false,
      showList: false,
      listas: [],
      labelCamposAutenticacao: {
        campo01: "Senha Operadora",
        apresenta01: true,
        campo02: "Client Id",
        apresenta02: true,
        campo03: "Client Secret",
        apresenta03: true,
      }
    };
  },
  components: { 
    FormNotch
  },
  methods: {
    async pesquisar() {
      this.listas = [];
      let codigoOperadora = $('#codigoOperadora').val();
      let response = await ajaxUtils.get('/massificados/corporativo/gerenciador-parceiros/integracao/rest/listar-pendente/' + codigoOperadora, true);
      if (response != null) {
        this.listas = response;
        if (this.listas.length == 0) alertUtils.alertError("Nenhuma integração localizada!");
      }
    },
    async ajustarCampos() {
      $('#senhaOperadora').val('');
      $('#clientSecret').val('');
      $('#clientId').val('');
      this.labelCamposAutenticacao.campo01 = "Senha Operadora";
      this.labelCamposAutenticacao.apresenta01 = true;
      this.labelCamposAutenticacao.campo02 = "Client Id";
      this.labelCamposAutenticacao.apresenta02 = true;
      this.labelCamposAutenticacao.campo03 = "Client Secret";
      this.labelCamposAutenticacao.apresenta03 = true;      
      //if (this.idCatalogoApi == "pos-venda-pos-venda") {}
      if (this.idCatalogoApi == "gestao-carteira-gestao-carteira") {
        this.labelCamposAutenticacao.campo01 = "Service Key";
        this.labelCamposAutenticacao.campo02 = "User";
        this.labelCamposAutenticacao.campo03 = "Password";
      }
      if (this.idCatalogoApi == "venda-automovel" ||
          this.idCatalogoApi == "venda-residencial" ||
          this.idCatalogoApi == "venda-vida" ||
          this.idCatalogoApi == "venda-empresarial" ||
          this.idCatalogoApi == "venda-condominio" ||
          this.idCatalogoApi == "venda-garantia" ||
          this.idCatalogoApi == "venda-imobiliario"
      ) {
        this.labelCamposAutenticacao.apresenta02 = false;
        this.labelCamposAutenticacao.apresenta03 = false;
      }
    },
    async salvarDados() {
      const tipo = this.tipoModal;
      const idIntegracaoApi = this.idIntegracaoApi;
      
      const senhaOperadora = $('#senhaOperadora').val();
      const clientSecret = $('#clientSecret').val();
      const clientId = $('#clientId').val();

      const bodyData = {
        "idIntegracaoApi" : String(idIntegracaoApi),
        "credencial": {
          "senhaOperadora": senhaOperadora != null ? String(senhaOperadora) : null,
          "clientId": clientId != null ? String(clientId) : clientId,
          "clientSecret": clientSecret != null ? String(clientSecret) : clientSecret
        }
      };

      let jsonRequest;

      let urlApi = '/massificados/corporativo/gerenciador-parceiros/integracao/configurar-operadora-aceite';

      if(tipo === 'CONFIGURACAO-PRODUCAO') urlApi = '/massificados/corporativo/gerenciador-parceiros/integracao/configurar-operadora-producao';
      
      jsonRequest = JSON.stringify(bodyData);

      let retorno = await ajaxUtils.postOK(urlApi, jsonRequest, 'Salvo com sucesso!', 'Erro ao salvar!');
      if (retorno) {
        this.closeModal();
        this.carregarDados();
      }

    },
    async closeModal() {
      this.showModal = false;

      $('.modal').hide();
      $('.modal-backdrop').hide();
      $('body').css('overflow', 'auto'); // Ativa a barra de rolagem
    },
    async openModal(tipo, id, idCatalogo) {
      this.tipoModal = await tipo;
      this.idIntegracaoApi = await id;
      this.idCatalogoApi = await idCatalogo;
      this.showModal = true;

      this.ajustarCampos();

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },
  },
  mounted() {}
}
</script>

<style>
.title-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 12vh;
}
.btn-group {
  align-items: center !important;
  display: flex !important;
  margin-top: -40px !important;
  margin-left: 13rem;
}
.top-button {
  margin-right: 10px !important;
  max-width: 200px;
  background: #2FC8B2 !important;
}
.off-button {
  margin-right: 10px !important;
  max-width: 200px;
  background: #FFFFFF !important;
}
.btn.btn-primary:hover {
  background: #ffffff !important;
  color: gray;
}
.btn.btn-primary.active {
  background: #2FC8B2 !important;
}
.btn-action-icon:active {
  background: black !important;
}
.btn-action-icon:focus {
  background:  black !important;
}
.btn.btn-primary {
  background: #ffffff !important;
  color: gray;
}
.btn-group, .btn-group-vertical {
  --mdb-btn-box-shadow: 0 4px 9px -4px rgba(0, 0, 0, 0.0) !important;
  --mdb-btn-hover-box-shadow: 0 8px 9px -4px rgba(0, 0, 0, 0), 0 4px 18px 0 rgba(0, 0, 0, 0.) !important;
}
.table>:not(caption)>*>* {
  padding: 1rem 0.4rem !important;
}
.td-icon {
  padding-left: 40px !important;
}
.pen-button {
  width: auto !important;
  height: 37px !important;
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  border: 1px solid #DDDDDD !important;
  border-radius: 6px !important;
  opacity: 1;
  padding-bottom: 30px !important
}
td.name-line {
  padding-left: 35px !important;
  padding-top: 3% !important;
}
td.status-line {
  padding-right: 65px !important;
  padding-top: 3% !important
}
.icon-line {
  font-size: 30px !important;
  margin-left: 52% !important;
}
/* Estilo opcional para o ícone, se necessário */
.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon-container i {
  font-size: 1.2rem;  /* Tamanho do ícone */
  cursor: pointer;  /* Adiciona um cursor de "mão" para indicar interatividade */
}
.actions-line {
  width: 16rem;
}
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.modal-content {
  background-color: #fff; /* Cor de fundo do modal */
  padding: 20px;
  border-radius: 8px;
}
.modal {
  display: block;
  max-height: 100rem !important;
  background: transparent !important;
}
input .form-control {
  width: 90% !important;
  padding-left: 12px !important;
}
.green-label {
  color: #007774; /* Cor do rótulo */
  font-weight: bold; /* Destaque para o rótulo */
  position: absolute; /* Posiciona o rótulo absolutamente */
  top: -1%; /* Centraliza verticalmente em relação ao textarea */
  left: 25px; /* Ajusta a posição horizontal conforme necessário */
  transform: translateY(-50%); /* Move o rótulo para cima para que fique na linha */
  background: white; /* Fundo branco para sobrepor a linha do textarea */
  padding: 0 5px; /* Adiciona um pouco de espaço ao redor do texto */
}
.green-label-color {
  color: #007774; /* Cor do rótulo label */
  font-weight: bold; /* Destaque para o rótulo */
  font-size: 15px
}
.form-outline {
  width: 25rem !important;
  height: 3rem !important;
}
.input-url {
  --mdb-card-cap-padding-y: 1.0 rem !important;
  border: 1px solid #DDDDDD !important;
  border-radius: 4px !important;
}
.input-modal {
  width: 97% !important;
  --mdb-card-cap-padding-y: 1.0 rem !important;
  border: 1px solid #DDDDDD !important;
  border-radius: 4px !important;
}
@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-sistemas/css/style.css';
</style>
